import { useEffect } from "react";
import { Alert, Button, Col, Row } from "react-bootstrap";
import Icon from "@mdi/react";
import { mdiCheckboxBlankOutline, mdiCheckboxMarkedOutline } from "@mdi/js";

import { CriteriaGroupEntity } from "src/entities/CriteriaGroupEntity";

type GroupsStepProps = {
	options: CriteriaGroupEntity[];
	selectedOptions: CriteriaGroupEntity[];
	onChange: (selectedOptions: CriteriaGroupEntity[]) => void;
	onCanAdvanceChange: (canAdvance: boolean) => void;
};

export default function GroupsStep({ options, selectedOptions, onChange, onCanAdvanceChange }: GroupsStepProps) {
	useEffect(() => {
		onCanAdvanceChange(true);
	}, [onCanAdvanceChange]);

	function handleToggle(group: CriteriaGroupEntity) {
		onChange(selectedOptions.some((option) => option.id === group.id) ? selectedOptions.filter((option) => option.id !== group.id) : [...selectedOptions, group]);
	}

	if (options.length === 0) {
		return <Alert variant="light">Nenhum grupo vinculado ao critério.</Alert>;
	}

	return (
		<Row className="w-100">
			{options.map((group) => {
				const checked = selectedOptions.some((option) => option.id === group.id);

				return (
					<Col key={group.id} md={12} className="mb-2">
						<Button
							type="button"
							variant="outline-dark"
							className={`d-flex align-items-center w-100 gap-3 rounded-3 border text-start h-100 ${checked ? "active" : ""}`}
							onClick={() => handleToggle(group)}
						>
							<div>
								<Icon path={checked ? mdiCheckboxMarkedOutline : mdiCheckboxBlankOutline} size={1} />
							</div>
							{group.title}
						</Button>
					</Col>
				);
			})}
		</Row>
	);
}
